import PaginatedController from 'core/controllers/paginated-controller';

export default class CloudOrgsDetailProjectsListController extends PaginatedController {}
